import { createAsyncThunk } from '@reduxjs/toolkit';

import { AdminApiPaths } from '../../../api/APIPaths';
import { IAdminUserScheduleData, IScheduleFullEvent } from '.';
import APIDataProvider, { TApiResponse } from '../../../api/ApiDataProvider';

export type TAdminGetUserSchedule = {
  userId: string;
  startDate: string;
  endDate: string;
  courseId?: string;
};

export type TAdminGetScheduleById = {
  sectionId: string;
};

const apiDataProvider = new APIDataProvider();

export const getUserSchedulesAsAdmin = createAsyncThunk(
  '/admin/schedule/getByUserId',
  async (data: TAdminGetUserSchedule) => {
    let path = `${AdminApiPaths.schedule}/list/${data.userId}?userId=${data.userId}&startDate=${data.startDate}&endDate=${data.endDate}`;

    if (data.courseId) {
      path += `&courseId=${data.courseId}`;
    }

    const response = await apiDataProvider.get<
      TApiResponse<IAdminUserScheduleData>
    >(path);

    return response.data;
  }
);

export const getScheduleByIdAsAdmin = createAsyncThunk(
  '/admin/schedule/getOneBySectionId',
  async (data: TAdminGetScheduleById) => {
    const path = `${AdminApiPaths.schedule}/${data.sectionId}?sectionId=${data.sectionId}`;

    const response = await apiDataProvider.get<
      TApiResponse<IScheduleFullEvent>
    >(path);

    return response.data;
  }
);
